import React, { Children, useEffect, useState, useRef } from 'react'

import classes from "./CreateVirtualSource.module.css";


import Modal from '../../../../Modal/Modal';
import Button2 from '../../../Button/Button2';

const CreateVirtualSource = ({ HandleSelectCamectModalForm, numInput, firmwareMajor, firmwareMinor, supportsCamect, siteType, supportsLiveView}) => {


    console.log(siteType)

    //------------------------------- Modal Logic  ----------------------------------------------
console.log(supportsLiveView)
    const ModalDialog = useRef();

    // call ref to clearStates method from child component ScheduledAction.
    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        //reset states for scheduled Action
        if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
            // Call the child method
            ClearStatesChildComponetRef.current.HandleResetAllStates();
        }
    }
    //-------------------------------------------------------------------------------------------------

    const handleSelectCamectModalForm = (AutomationID) => {
        HandleCloseModal();
        HandleSelectCamectModalForm(AutomationID);
    }

    return (
        <>
            <Modal ref={ModalDialog} title={"Add device"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "700px", minHeight: "420.5px" }} modalLayoutStyle={{ alignItems: "center" }}>
                <div className={classes.container}>
                    <h2 style={{color:"#6e6e6e"}}> Which type of device?</h2>
                
    
                    {/* Show CCTV button only if firmware version is above or equal to 1.7 */}
                    {(firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 7)) && (
                         <Button2 style={{ 
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }
                    }    onClick={() => handleSelectCamectModalForm(7)}>
                            <h4 style={{margin:"0px"}}>CCTV Integration</h4>
                        </Button2>
                    )}

                    {/* Show CCTV button only if firmware version is above or equal to 1.7 */}
                    {supportsLiveView && (
                         <Button2 style={{ 
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }
                    }    onClick={() => handleSelectCamectModalForm(13)}>
                            <h4 style={{margin:"0px"}}>Live view camera</h4>
                        </Button2>
                    )}
                    
    
                    {/* Show Sigfox button only if firmware version is above or equal to a certain version */}
                    {numInput > 4 && (
                         <Button2 style={{ 
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }
                    }    onClick={() => handleSelectCamectModalForm(1)}>
                            <h4 style={{margin:"0px"}}>Anywhere sensor - Lite</h4>
                        </Button2>
                    )}
    
                    {/* Show IOTA button only if firmware version is above or equal to a certain version */}
                    {numInput > 4 && (
                         <Button2 style={{ 
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }
                    }    onClick={() => handleSelectCamectModalForm(4)}>
                            <h4 style={{margin:"0px"}}>Anywhere sensor - Industrial</h4>
                        </Button2>
                    )}

                    <Button2 style={{
                        minWidth: "350px", 
                        minHeight: "50px", 
                        display: "flex", 
                        justifyContent: "center", 
                        alignItems: "center"
                    }}    
                    onClick={() => handleSelectCamectModalForm(6)}>
                        <h4 style={{margin:"0px"}}>Smart Padlock or Keybox</h4>
                    </Button2>

                    <Button2 style={{
                        minWidth: "350px", 
                        minHeight: "50px", 
                        display: "flex", 
                        justifyContent: "center", 
                        alignItems: "center"
                    }}    
                    onClick={() => handleSelectCamectModalForm(5)}>
                        <h4 style={{margin:"0px"}}>Gateway</h4>
                    </Button2>
            
                    {/* <button className={classes.listOption} onClick={() => handleSelectCamectModalForm(2)}>
                        <h4>Smart Lock</h4>
                    </button> */}
                    
                </div>
            </Modal>
    
            <div className={classes.GroupCardContentLayout} onClick={() => HandleShowModal()}>
                <div className={`${classes.container} ${classes.rotate}`}>
                    <h2 className={classes.rotate}>+</h2>
                </div>
            </div>
        </>
    );
    
}

export default CreateVirtualSource;




